// @flow

import React from 'react';
import styled from 'styled-components';
import type { Theme } from '../../../types';

const Question = styled<any, Theme>('h1')`
  color: ${props => props.theme.faq.questionDetail.question.color};
  font-weight: ${props => props.theme.faq.questionDetail.question.fontWeight};
  font-size: 1.5rem;
  line-height: 1.2em;
  margin-bottom: 1em;
`;

const Answer = styled<any, Theme>('div')`
  color: ${props => props.theme.faq.questionDetail.answer.color};
  font-weight: ${props => props.theme.faq.questionDetail.answer.fontWeight};
  line-height: 1.5em;

  p {
    line-height: 1.5em;
    margin-bottom: 2em;
    a {
      color: ${props => props.theme.faq.questionDetail.answer.linkColor};
      &:hover {
        color:  ${props => props.theme.faq.questionDetail.answer.linkHoverColor};
      }
    }
  }
`;

type Props = {|
  question: string,
  answer: string,
|};

const QuestionDetail = ({
  question,
  answer,
}: Props) => (
  <section>
    <Question dangerouslySetInnerHTML={{ __html: question }} />
    <Answer dangerouslySetInnerHTML={{ __html: answer }} />
  </section>
);

export default QuestionDetail;
